<template>
  <b-card class="h-100">
    <h5 class="font-weight-bold">
      Upload Details
    </h5>
    <b-card-body class="p-0 align-items-center h-100">
      <b-list-group flush class="h-100 list">
        <b-list-group-item
          ><b-row class="font-weight-bold">Owner</b-row>
          <b-row
            ><b-col cols="3" md="2" lg="2" class="px-0 pt-1"
              ><b-avatar
                button
                v-if="userAvatar"
                variant="light"
                :src="userAvatar"
              ></b-avatar>
              <b-avatar
                button
                v-else
                variant="primary"
                :text="userInitials"
              ></b-avatar></b-col
            ><b-col style="word-break: break-word;"
              ><b-row class="font-weight-bold"
                >{{ file.user ? file.user.full_name : '' }}
                {{ file.user && file.user.mine ? '(You)' : '' }}</b-row
              ><b-row>{{ file.user.email }}</b-row></b-col
            >
          </b-row></b-list-group-item
        >
        <b-list-group-item v-show="isShareable">
          <b-row class="font-weight-bold">Shared to</b-row>
          <b-row>
            <b-button
              v-if="fileSharesCount"
              variant="link"
              class="btn text-dark text-decoration-none btn-link p-0 h-auto"
              @click="openShareFile"
            >
              <span class="mr-2 align-middle">
                <b-icon scale="1" icon="eye" aria-hidden="true"></b-icon>
              </span>
              {{ fileSharesCount + ' people' }}
            </b-button>
            <div v-else>
              <span class="mr-2">
                <b-icon scale="1" icon="eye-slash" aria-hidden="true"></b-icon>
              </span>
              None
            </div>
          </b-row>
        </b-list-group-item>
        <b-list-group-item>
          <b-row class="font-weight-bold">Status</b-row>
          <b-row>
            <b-badge
              pill
              :variant="statusBadge(fileStatus)"
              class="badge-hovered text-capitalize"
            >
              {{ fileStatus }}
            </b-badge>
            <span v-if="file.template_id" class="pt-1 pl-2">
              <b-link
                active
                :to="{
                  name: 'provider.list-page',
                  params: { id: file.template_id }
                }"
                ><u>Browse for licence providers</u></b-link
              >
            </span>
          </b-row>
        </b-list-group-item>
        <b-list-group-item v-if="fileStatus === 'Rejected'">
          <b-row class="font-weight-bold">Reason</b-row>
          <b-row
            ><span v-if="file.file_rejects.length > 0">{{
              file.file_rejects[0].reason
            }}</span>
          </b-row>
        </b-list-group-item>
        <b-list-group-item
          ><b-row class="font-weight-bold">Uploaded</b-row>
          <b-row>{{ uploaded }}</b-row></b-list-group-item
        >
      </b-list-group>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    file: {
      type: Object,
      required: true
    }
  },

  computed: {
    userAvatar() {
      return this.file.user && this.file.user.avatar
        ? this.file.user.avatar_permanent_url
        : ''
    },
    userInitials() {
      return this.file.user && this.file.user.full_name
        ? this.file.user.full_name
            .match(/(^\S\S?|\b\S)?/g)
            .join('')
            .match(/(^\S|\S$)?/g)
            .join('')
            .toUpperCase()
        : ''
    },
    uploaded() {
      return this.getTimeDiff(this.file.updated_at)
    },
    fileSharesCount() {
      return this.file.file_shares.length
    },
    fileStatus() {
      return this.file.status
        .trim()
        .toLowerCase()
        .replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()))
    },
    isShareable() {
      return (
        this.file.status === 'valid' ||
        this.file.status === 'not started' ||
        this.file.status === 'expiring soon'
      )
    }
  },

  methods: {
    openShareFile() {
      return this.$emit('openShareFile', this.file.file_shares)
    },
    statusBadge(status) {
      return status === 'Valid'
        ? 'success'
        : status === 'Pending Approval'
        ? 'warning'
        : status === 'Rejected'
        ? 'danger'
        : 'secondary'
    }
  }
}
</script>

<style lang="scss" scoped>
.badge-hovered {
  font-size: 15px;
  font-weight: 700;
  padding: 5px 20px 5px 20px;
  background: #dadde2 0% 0% no-repeat padding-box;
  color: #3f4858 !important;

  &.badge-success {
    background: #d1ffef 0% 0% no-repeat padding-box !important;
    color: #00d392 !important;
  }

  &.badge-danger {
    background: #ffe2e2 0% 0% no-repeat padding-box !important;
    color: #e52c00 !important;
  }

  &.badge-warning {
    background: #fff3cc 0% 0% no-repeat padding-box !important;
    color: #a07602 !important;
  }
}
</style>
